import { Component, OnDestroy, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import { TestNavigationService } from '../../../../../../services/test-navigation.service';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'ipp-microphone-check',
    template: require('./ipp-microphone-check.component.html')
})
export class IppMicrophoneCheckComponent implements OnInit {
    stationNumber: number;
    testTakerPhotoUrl: string;
    testTakerInfo: PgRendererDto.TestTakerStationAssignment = {} as any;

    constructor(
        private testNavigationService: TestNavigationService,
    ) {
    }

    ngOnInit() {
        this.stationNumber = 1;
        this.testTakerPhotoUrl = this.renderPhoto();
        this.testTakerInfo.FirstName = "";
        this.testTakerInfo.LastName = "";
    }

    audioCheckCompleted() {
        this.testNavigationService.goNext(true);
    }

    private renderPhoto() {
        let canvas = document.createElement('canvas');
        canvas.width = 300;
        canvas.height = 300;
        let context = canvas.getContext("2d");
        context.font = "bold 20px 'Trebuchet MS'"
        context.textAlign = "center"
        context.textBaseline = "middle"
        context.fillText("Your Photo Will Appear Here", canvas.width / 2, canvas.height / 2);
        return canvas.toDataURL();
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/ipp/ipp-microphone-check/ipp-microphone-check.component.ts